





























import { Vue, Component, Prop } from 'vue-property-decorator';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import Checkbox from '@/components/Checkbox.vue';
import { IField } from '@/fields/types/field';
import FieldSettingsContainer from '@/fields/context-menu/components/FieldSettingsContainer.vue';
import { fieldLabelMaxLength } from '@/common/database-max-values';

@Component({
  components: {
    Input,
    Button,
    Checkbox,
    FieldSettingsContainer,
  },
  data: () => ({
    fieldLabelMaxLength,
  }),
})
export default class SignatureFieldSettings extends Vue {
  @Prop() field!: IField;
  @Prop() height: string;
  @Prop() isTemplate: boolean;

  label: string = this.fieldLabel;
  isEditable: boolean = this.field.isEditable;

  get fieldLabel(): string {
    return this.field ? this.field.label : '';
  }

  handleIsEditable(value: boolean) {
    this.isEditable = value;
  }

  handleInput(payload: string) {
    this.label = payload;
  }

  handleUpdate(label: string, isEditable: boolean) {
    const payload: Partial<IField> = { label, isEditable };
    this.$emit('update', payload);
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.handleUpdate(this.label, this.isEditable);
    }
  }

  mounted() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }
}
